/* eslint-disable no-unused-vars */
import {
  get as getAxios,
  post as postAxios,
  put as putAxios,
  deleteCall as deleteAxios,
} from "../apiHandler";
import { isEmptyObj } from "../../utils/helper";

const endPoint = process.env.REACT_APP_API_BASE_URL;
const PAGE_SIZE = 10;

// const accessTokenFromLocal = "0fc0515a-d081-4b4a-83ab-7c104c2e1357";

const get = (url, { data, accessToken }) =>
  getAxios(url, { data, accessToken, endPoint });
const post = (url, { accessToken, data, params }) =>
  postAxios(url, { accessToken, data, endPoint, params });
const put = (url, { accessToken, data, params }) =>
  putAxios(url, { accessToken, data, endPoint, params });
const deleteCall = (url, { accessToken, data, params }) =>
  deleteAxios(url, { accessToken, data, endPoint, params });

export default class Appointment {
  static forwardAppointment({ data, memberId }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = put(`/api/appointment/${memberId}/forward`, {
      accessToken: accessTokenFromLocal,
      data: {
        areaId: data.areaId,
        zoneId: data.zoneId,
        regionId: data.regionId,
        chapterId: data.chapterId,
        districtId: data.districtId,
      },
    });

    Appointment.forwardAppointment.cancel = request.cancel;
    return request;
  }

  static searchMembers(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = post(`/api/members/search`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    Appointment.searchMembers.cancel = request.cancel;
    return request;
  }

  static initiateAppointmentApplication(data, memberId) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = post(`/api/members/${memberId}/appointmentApplications`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    Appointment.initiateAppointmentApplication.cancel = request.cancel;
    return request;
  }

  static getAppointmentApplications(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/appointments/applications`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    Appointment.getAppointmentApplications.cancel = request.cancel;
    return request;
  }

  static appointmentARCReview(data, memberId, applicationId) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = put(
      `/api/members/${memberId}/appointmentApplications/${applicationId}/review`,
      {
        accessToken: accessTokenFromLocal,
        data,
      }
    );
    Appointment.appointmentARCReview.cancel = request.cancel;
    return request;
  }

  static submitAppointment(data, memberId) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = post(`/api/members/${memberId}/appointmentApplications`, {
      data,
      accessToken: accessTokenFromLocal,
    });
    Appointment.submitAppointment.cancel = request.cancel;
    return request;
  }

  static reviewAppointment(data, memberId, applicationId) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = put(
      `/api/members/${memberId}/appointmentApplications/${applicationId}/review`,
      {
        accessToken: accessTokenFromLocal,
        data,
      }
    );

    Appointment.reviewAppointment.cancel = request.cancel;
    return request;
  }

  static acceptAppointment(memberId, applicationId) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = put(
      `/api/members/${memberId}/appointmentApplications/${applicationId}/acceptAppointment`,
      {
        accessToken: accessTokenFromLocal,
      }
    );

    Appointment.acceptAppointment.cancel = request.cancel;
    return request;
  }

  static rejectAppointment(data, memberId, applicationId) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = put(
      `/api/members/${memberId}/appointmentApplications/${applicationId}/cancelAppointment`,
      {
        accessToken: accessTokenFromLocal,
        data,
      }
    );

    Appointment.rejectAppointment.cancel = request.cancel;
    return request;
  }

  static markAppointment(memberId, applicationId) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = post(
      `/api/members/${memberId}/appointmentApplications/${applicationId}/markAppointment`,
      {
        accessToken: accessTokenFromLocal,
      }
    );

    Appointment.markAppointment.cancel = request.cancel;
    return request;
  }

  static split(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = post(`/api/split/structure`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    Appointment.split.cancel = request.cancel;
    return request;
  }

  static updateSplitStructure({ data, parentId }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = put(`/api/split/structure/${parentId}`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    Appointment.updateSplitStructure.cancel = request.cancel;
    return request;
  }

  static getBeforeSplitStructure(structureId) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(
      `/api/split/structure/${structureId}/organogram/before`,
      {
        accessToken: accessTokenFromLocal,
      }
    );

    Appointment.getBeforeSplitStructure.cancel = request.cancel;
    return request;
  }

  static getAfterSplitStructure(structureId) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(
      `/api/split/structure/${structureId}/organogram/after`,
      {
        accessToken: accessTokenFromLocal,
      }
    );

    Appointment.getAfterSplitStructure.cancel = request.cancel;
    return request;
  }

  static acceptedAppointment(applicationId, data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = put(
      `/api/appointments/applications/${applicationId}/acceptAppointment`,
      {
        accessToken: accessTokenFromLocal,
        data,
      }
    );

    Appointment.acceptedAppointment.cancel = request.cancel;
    return request;
  }

  static directAppointmentApplications(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/appointments/directApplications`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    Appointment.directAppointmentApplications.cancel = request.cancel;
    return request;
  }

  static specialGroupDirectAppointmentApplications(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/appointments/specialGroup/directApplications`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    Appointment.specialGroupDirectAppointmentApplications.cancel =
      request.cancel;
    return request;
  }

  static directAppointment(memberId, data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = post(`/api/members/${memberId}/directAppointments`, {
      accessToken: accessTokenFromLocal,
      data,
    });
    Appointment.directAppointment.cancel = request.cancel;
    return request;
  }

  static specialGroupDirectAppointment(memberId, data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = post(
      `/api/members/${memberId}/specialGroup/directAppointments`,
      {
        accessToken: accessTokenFromLocal,
        data,
      }
    );
    Appointment.specialGroupDirectAppointment.cancel = request.cancel;
    return request;
  }

  static directAppointmentRemoveApplications(params, body) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = put(`/api/appointments/directApplications`, {
      accessToken: accessTokenFromLocal,
      data: body,
      params,
    });

    Appointment.directAppointmentRemoveApplications.cancel = request.cancel;
    return request;
  }

  static directAppointmentDeleteApplications(params, body) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = deleteCall(`/api/appointments/directApplications`, {
      accessToken: accessTokenFromLocal,
      data: body,
      params,
    });

    Appointment.directAppointmentDeleteApplications.cancel = request.cancel;
    return request;
  }

  static deleteStructure(structureId) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = deleteCall(`/api/split/structure/${structureId}`, {
      accessToken: accessTokenFromLocal,
    });

    Appointment.deleteStructure.cancel = request.cancel;
    return request;
  }

  static appointmentTracking(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/appointments/applications/tracking`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    Appointment.appointmentTracking.cancel = request.cancel;
    return request;
  }

  static appointmentVotingTracker(data, applicationId) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(
      `/api/appointments/applications/${applicationId}/votings`,
      {
        accessToken: accessTokenFromLocal,
        data,
      }
    );
    Appointment.appointmentVotingTracker.cancel = request.cancel;
    return request;
  }

  static forcePushAppointment(data, memberId, applicationId) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = put(
      `/api/members/${memberId}/appointmentApplications/${applicationId}/push`,
      {
        accessToken: accessTokenFromLocal,
        data,
      }
    );

    Appointment.forcePushAppointment.cancel = request.cancel;
    return request;
  }

  static getInteractionList(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/members/interaction/dropdown`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    Appointment.getInteractionList.cancel = request.cancel;
    return request;
  }

  static AppointmentApplyEligibility(memberId) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = post(
      `/api/members/${memberId}/appointmentApplications/eligible`,
      {
        accessToken: accessTokenFromLocal,
      }
    );

    Appointment.AppointmentApplyEligibility.cancel = request.cancel;
    return request;
  }

  static getStructureChiefs(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/members/structureChiefs`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    Appointment.getStructureChiefs.cancel = request.cancel;
    return request;
  }

  static resendConsent(memberId, applicationId) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = put(
      `/api/members/${memberId}/appointmentApplications/${applicationId}/consent`,
      {
        accessToken: accessTokenFromLocal,
      }
    );

    Appointment.resendConsent.cancel = request.cancel;
    return request;
  }

  static appointmentVoting(data, applicationId) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(
      `/api/appointments/applications/${applicationId}/tracking/proposals`,
      {
        accessToken: accessTokenFromLocal,
        data,
      }
    );

    Appointment.AppointmentApplyEligibility.cancel = request.cancel;
    return request;
  }
  //

  static getOrganogramByStructureId(structureId) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/split/structure/${structureId}/organogram`, {
      accessToken: accessTokenFromLocal,
    });

    Appointment.getOrganogramByStructureId.cancel = request.cancel;
    return request;
  }

  static submitProposedOrganogramByStructureId(structureId, data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = put(
      `/api/split/structure/${structureId}/organogram/proposed`,
      {
        accessToken: accessTokenFromLocal,
        data,
      }
    );

    Appointment.submitProposedOrganogramByStructureId.cancel = request.cancel;
    return request;
  }

  static AppointmentCancelRequest(data, memberId, applicationId) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = put(
      `/api/members/${memberId}/appointmentApplications/${applicationId}/cancel`,
      {
        accessToken: accessTokenFromLocal,
        data,
      }
    );
    Appointment.AppointmentCancelRequest.cancel = request.cancel;
    return request;
  }

  //

  static AppointmentAdminPush(memberId, applicationId) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = put(
      `/api/members/${memberId}/appointmentApplications/${applicationId}/push/direct`,
      {
        accessToken: accessTokenFromLocal,
      }
    );
    Appointment.AppointmentCancelRequest.cancel = request.cancel;
    return request;
  }
}
